import React, { Component } from "react";

class Rates extends Component {
  render() {
    return (
      <section style={{ backgroundColor: "#fff" }}>
        <div className="">
          <div className="container marketingSection pt-3 pb-5">
            <div className="row align-items-center">
              <div
                className="col-md-12 text-center"
                style={{ marginTop: "20px" }}
              >
                <h2>GET YOCO</h2>
                <h3>Perfect for all businesses. Big or small.</h3>
                <ul className="tickList" style={{ marginTop: 0 }}>
                  <li>No set up fees</li>
                  <li>No monthly rental fees</li>
                  <li>No admin fees</li>
                  <li>No settlement fees</li>
                  <li>No lock-in contracts</li>
                  <li>No surprises</li>
                  <li>Same rates for all major cards</li>
                  <li>Get paid in only 2 business days</li>
                </ul>
                <div className="clearfix" />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Rates;



// WEBPACK FOOTER //
// ./src/sections/promos/transactionRates/transactionRates.js